import React from 'react'
import './LandingPage2.module.css';
import Navbar from './Navbar/Navbar';
import Visncare from './Visncare/Visncare';
import VisionDissatisfaction from './VisionDissatisfaction/VisionDissatisfaction';
import EdofDesign from './EdofDesign/EdofDesign';
import Deseyne from './Deseyne/Deseyne';
import NatureBluePrint from "./NatureBluePrint/NatureBluePrint"
import LifeFocus from './LifeFocus/LifeFocus';
import TopBar from '../EdofSectionNew2/TopBar/TopBar';
import Footer2 from '../Footer2/Footer2';

function LandingPage2() {
  return (
    <div>
      <header>
        <TopBar />
        <Navbar />
      </header>
      <main>
        <Visncare />
        <VisionDissatisfaction />
        <Deseyne />
        <NatureBluePrint />
        <EdofDesign />
        <LifeFocus />
      </main>
      <Footer2 />
    </div>
  )
}

export default LandingPage2